import { RedoShopifyFulfillmentHoldReason } from "@redotech/redo-fulfillment-group-common/fulfillment-hold-reason";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const placeHolds = {
  name: "placeHolds" as const,
  input: z.object({
    fulfillmentGroupIds: z.array(z.string()),
    holdUntil: z.coerce.date().nullish(),
    reason: z.string().nullish(),
    reasonOption: createEnum(RedoShopifyFulfillmentHoldReason),
  }),
  output: z.object({ failedGroupIds: z.array(z.string()) }),
};
